import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./RoutingMenu.scss";
import { Box, IconButton } from "@mui/material";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { useSelector } from "react-redux";
function ExpandedRoutingMenu({
  handleMenu,
  menuItems,
  finalMenuItems,
  disabledMenuItems,
  isMenuItemDisabled,
  systemMenuItems,
  open,
  handleMenuItemClick,
  activeMenuItem,
  matchingItems,
  allowedAppIds,
}) {
  const menuRef = useRef();
  const requiredConstants = useSelector((state) => state.constants);
  let user = useSelector((state) => state.login);
  const [role, setRole] = useState([]);
  const systemRoles = async () => {
    const userSecurityRole = user["securityRole"];

    if (Array.isArray(userSecurityRole)) {
      // If securityRole is an array, collect all roles
      const roles = userSecurityRole.flatMap((role) =>
        requiredConstants.systemRoles.filter(
          (systemRole) => systemRole.securityrole.roleid === role.roleid,
        ),
      );
      setRole(roles || []);
    } else if (userSecurityRole && typeof userSecurityRole === "object") {
      // If securityRole is an object, process as a single role
      const role = requiredConstants.systemRoles.filter(
        (systemRole) =>
          systemRole.securityrole.roleid === userSecurityRole.roleid,
      );
      setRole(role || []);
    } else {
      setRole([]);
    }
  };
  const handleMenuContraction = () => {
    handleMenu();
  };
  useEffect(() => {
    systemRoles();
  }, []);
  // If you click outside the menu, it would close the menu
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleMenu();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);
  const offlineMenuItems = menuItems.filter((item) =>
    disabledMenuItems.includes(item.id),
  );
  const configVariables = useSelector((state) => state.config.baseConfig);
  const userRoleId = sessionStorage.getItem("userSecurityRoleId");
  const hiddenForExternalPayrollAdmin = ["settings", "admin"];

  const payrollAdminId = configVariables?.payRollAdminId
    ? String(configVariables.payRollAdminId).trim()
    : "";

  const isExternalPayrollAdmin =
    payrollAdminId !== "" && userRoleId === payrollAdminId;

  const systemItems = menuItems
    .filter((item) => systemMenuItems.includes(item.id))
    .filter((item) => allowedAppIds.includes(item.appid) || item.id === "")
    .filter((item) => {
      if (isExternalPayrollAdmin) {
        return !hiddenForExternalPayrollAdmin.includes(item.id);
      }
      return true;
    });

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          padding: 0,
          marginRight: "20px",
          marginBottom: "10px",
        }}
      >
        <Box sx={{ flexGrow: 1, borderRadius: "8px", color: "#E7E7E7" }} />

        <IconButton
          onClick={handleMenuContraction}
          sx={{
            width: "25px",
            height: "25px",
            borderRadius: "8px",
            marginTop: "5px",
            marginLeft: "20px",
            border: "1px solid #B0B0B0",
            "&:hover": { backgroundColor: "#E0E0E0" },
          }}
        >
          <KeyboardArrowLeft
            sx={{
              transition: "transform 0.3s ease",
              color: "#9E9E9E",
            }}
          />
        </IconButton>
      </Box>

      {/* Searched Items */}
      {matchingItems.length > 0 && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "5px",
            justifyItems: "center",
            alignItems: "center",
            // paddingBottom: "16px",
            width: "93%",
            backgroundColor: "#F5F5F5",
            padding: "16px",
            borderRadius: "10px",
            marginBottom: "10px",
            overflowY: "auto",
            // flexGrow: 1,
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#cccccc",
            },
            "@media (max-height: 900px)": {
              height: matchingItems.length > 2 ? "18%" : "12%",
              paddingBottom: "40px",
            },
          }}
        >
          {matchingItems.map((data, i) => (
            <Box key={i} sx={{ width: "100%" }}>
              <Link
                to={isMenuItemDisabled(data.id) ? "#" : `/${data.id}`}
                style={{
                  textDecoration: "none",
                  width: "100%",
                  height: "120%",
                }}
              >
                <Box
                  onClick={() => handleMenuItemClick(data.id)}
                  sx={{
                    width: "100%",
                    padding: "10px 0px",
                    gap: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: isMenuItemDisabled(data.id)
                      ? "not-allowed"
                      : "pointer",
                    transition: "background-color 0.3s",
                    borderRadius: "8px",
                    opacity: isMenuItemDisabled(data.id) ? 0.5 : 1,
                    backgroundColor:
                      activeMenuItem === data.id ? "#f5f5f5" : "",
                    "&:hover": isMenuItemDisabled(data.id)
                      ? {}
                      : {
                          backgroundColor: "#e9eef6",
                          color: "#7a51e5",
                          "& .menu-item-text": {
                            color: "#555",
                          },
                        },
                  }}
                >
                  <img
                    src={data.icon}
                    alt={data.text}
                    style={{
                      height: "20px",
                      width: "20px",
                      marginBottom: "8px",
                      filter:
                        "brightness(0) saturate(100%) invert(16%) sepia(4%) saturate(199%) hue-rotate(169deg) brightness(94%) contrast(88%)",
                    }}
                    loading="lazy"
                  />
                  <Box
                    className="menu-item-text"
                    sx={{
                      textAlign: "center",
                      color: "#212529",
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "color 0.3s ease",
                    }}
                  >
                    {data.text}
                  </Box>
                </Box>
              </Link>
            </Box>
          ))}
        </Box>
      )}

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          width: "100%",
          padding: "0 16px",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "5px",
            justifyItems: "center",
            alignItems: "center",
            paddingBottom: "16px",
          }}
        >
          {finalMenuItems.map((item) => (
            <Link
              to={item.id ? `/${item.id}` : "#"}
              key={item.id}
              style={{ textDecoration: "none", color: "#555", width: "100%" }}
            >
              <Box
                onClick={() => handleMenuItemClick(item.id)}
                sx={{
                  width: "100%",
                  padding: "5px 0",
                  gap: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: matchingItems.length === 0 ? "pointer" : "default",
                  transition: "background-color 0.3s",
                  borderRadius: "8px",
                  backgroundColor: activeMenuItem === item.id ? "#f5f5f5" : "",
                  "&:hover": {
                    backgroundColor: "#e9eef6",
                    color: "#6a3be6",
                    "& .menu-item-text": {
                      color: "#555",
                    },
                  },
                }}
              >
                <img
                  src={activeMenuItem === item.id ? item.activeIcon : item.icon}
                  alt={item.text}
                  style={{
                    height: "20px",
                    marginBottom: "8px",
                    filter:
                      "brightness(0) saturate(100%) invert(16%) sepia(4%) saturate(199%) hue-rotate(169deg) brightness(94%) contrast(88%)",
                  }}
                  loading="lazy"
                />
                <Box
                  className="menu-item-text"
                  sx={{
                    textAlign: "center",
                    color: "#212529",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "color 0.3s ease",
                  }}
                >
                  {item.text}
                </Box>
              </Box>
            </Link>
          ))}
        </Box>

        {!isExternalPayrollAdmin && (
          <Box sx={{ textAlign: "center", color: "#ddd" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                marginBottom: "16px",
                color: "#ddd",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  borderBottom: "1px solid #ddd",
                  marginRight: "10px",
                }}
              ></Box>
              <Box
                sx={{
                  fontSize: "14px",
                  textAlign: "center",
                  color: "#ddd",
                  fontWeight: 500,
                }}
              >
                Offline
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  borderBottom: "1px solid #ddd",
                  marginLeft: "10px",
                }}
              ></Box>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "5px",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              {(offlineMenuItems || []).map((item) => (
                <Box
                  key={item?.id}
                  sx={{
                    padding: "5px 0",
                    textAlign: "center",
                    color: "#ddd",
                    cursor: "not-allowed",
                    opacity: 0.5,
                    gap: "10px",
                  }}
                >
                  <img
                    src={item?.icon}
                    alt={item?.text || ""}
                    style={{
                      height: "20px",
                      marginBottom: "8px",
                      opacity: 0.5,
                    }}
                    loading="lazy"
                  />
                  <Box sx={{ fontSize: "14px" }}>{item?.text || ""}</Box>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* System Section */}
        <Box sx={{ textAlign: "center", color: "#ddd", marginTop: "16px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              color: "#ddd",
              marginBottom: "16px",
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                borderBottom: "1px solid #ddd",
                marginRight: "10px",
              }}
            ></Box>
            <Box
              sx={{
                fontSize: "14px",
                textAlign: "center",
                color: "#ddd",
                fontWeight: 500,
              }}
            >
              System
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                borderBottom: "1px solid #ddd",
                marginLeft: "10px",
              }}
            ></Box>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "5px",
              justifyItems: "center",
              alignItems: "center",
              paddingBottom: "16px",
            }}
          >
            {systemItems.map((item) => (
              <Link
                to={item.id ? `/${item.id}` : "#"}
                key={item.id}
                style={{ textDecoration: "none", color: "#555", width: "100%" }}
              >
                <Box
                  onClick={() => handleMenuItemClick(item.id)}
                  sx={{
                    width: "100%",
                    padding: "5px 0",
                    gap: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: matchingItems.length === 0 ? "pointer" : "default", // Only show pointer if not searching
                    transition: "background-color 0.3s",
                    borderRadius: "8px",
                    backgroundColor:
                      activeMenuItem === item.id ? "#f5f5f5" : "",
                    "&:hover": {
                      backgroundColor: "#e9eef6",
                      color: "#6a3be6", // Change text color on hover
                      "& .menu-item-text": {
                        // Ensure the text becomes purple on hover
                        color: "#555",
                      },
                    },
                  }}
                >
                  <img
                    src={
                      activeMenuItem === item.id ? item.activeIcon : item.icon
                    }
                    alt={item.text}
                    style={{
                      height: "20px",
                      marginBottom: "8px",
                      filter:
                        "brightness(0) saturate(100%) invert(16%) sepia(4%) saturate(199%) hue-rotate(169deg) brightness(94%) contrast(88%)",
                    }}
                    loading="lazy"
                  />
                  <Box
                    className="menu-item-text" // Use this class to target the text for hover
                    sx={{
                      textAlign: "center",
                      color: "#212529", // Default text color
                      fontSize: "14px",
                      fontWeight: "500",
                      transition: "color 0.3s ease", // Smooth transition for the color change
                    }}
                  >
                    {item.text}
                  </Box>
                </Box>
              </Link>
            ))}
          </Box>
        </Box>
      </Box>
      {/* </Drawer> */}
    </>
  );
}

export default ExpandedRoutingMenu;
